import './styles/graphic.scss';
import {
  geoPath,
  geoAlbersUsa,
  scaleLinear,
  format,
  scaleThreshold,
} from 'd3';
import * as topojson from 'topojson-client';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
// import mapdata from './data/map.json'; // note: this should be a topojson file
import * as axios from 'axios';
import { Child } from 'pym.js';
import innerlines from './data/us_innerlines.json';
import states_json from './data/us_states.json';
import state_centers from './data/us_state_postals.json';
import 'regenerator-runtime/runtime';

// prep dayjs for our purposes
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
  months: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  monthsShort: [
    'Ene.',
    'Feb.',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Ago.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dic.',
  ],
});

let mapParams;

// check for URL params
function checkParams() {
  const url = window.location.href;

  console.log('url', url);

  // Parse params
  const getParams = function (url) {
    const params = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  mapParams = getParams(url);

  if (!('scale' in mapParams)) {
    mapParams.scale = 'low';
  }
}


export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;

  window.pymChild = new Child();


  // function to get the latest map data
  const fetchData = async (data_url) => {
    const response = await axios.get(data_url);
    return response.data;
  };

  // function to draw the map
  const drawMap = (mapdata) => {
    // console.log(mapdata);

    // // -- parse map's update and valid-to times -- // //

    // map object key can vary, so detecting it first
    // (also used later for the map)
    const topo_object_key = Object.keys(mapdata.objects)[0];
    console.log('Using latest map object key:', topo_object_key);

    // nab the issue and end times of the first geometry (they are all the same)
    // example: 2021-06-16 08:56:52
    const issue_time = {};
    const valid_until_time = {};

    issue_time.raw = mapdata.objects[
      topo_object_key
    ].geometries[0].properties.ISSUE_TIME;
    valid_until_time.raw = mapdata.objects[
      topo_object_key
    ].geometries[0].properties.END_TIME;

    // use dayjs to parse those dates and pull out month + day
    issue_time.zulu = dayjs.utc(issue_time.raw, 'YYYY-MM-DD HH:mm:ss');

    issue_time.display = dayjs
      .tz(issue_time.zulu, 'America/New_York')
      .format('MMMM D, YYYY');
    valid_until_time.display = dayjs
      .tz(valid_until_time.zulu, 'America/New_York')
      .format('MMMM D, YYYY');

    console.log('current timestamps', issue_time, valid_until_time);

    // Note ... these IDs can be added in the Google doc as:
    //    <span id="v-updated"></span> &
    //    <span id="v-valid-until"></span>
    // Because of the load order, in development these elements don't exist at this
    // point in the code. The spans get hydrated in staging and publishing though.
    if (document.getElementById('v-updated')) {
      document.getElementById('v-updated').innerHTML = issue_time.display;
    }

    if (document.getElementById('v-valid-until')) {
      document.getElementById('v-valid-until').innerHTML = valid_until_time.display;
    }

    // // -- legend code -- // //

    const legend_title = 'Pronóstico de precipitación de 7 días, en pulgadas';
    const color_width = 40; // width in pixels
    let breaks;
    let colors;

    if (mapParams.scale == 'high') {
      colors = '#ffffd9,#edf8b1,#c7e9b4,#7fcdbb,#41b6c4,#1d91c0,#225ea8,#253494,#081d58'.split(',');
      breaks = ['0,5', 1, 2, 3, 4, 5, 7, '10"'];
    } else {
      breaks = ['0,1', '0,5', '0,75', '1,25', '1,5', '2"'];
      colors = [
        '#ffffcc',
        '#c7e9b4',
        '#7fcdbb',
        '#41b6c4',
        '#1d91c0',
        '#225ea8',
        '#0c2c84',
      ];
    }

    container
      .append('div')
      .attr('class', 'v-legend-hed')
      .html(legend_title);

    const map_legend = container
      .append('div')
      .attr('class', 'v-legend-colors-container')
      .attr('width', initialWidth);

    map_legend.selectAll('.v-legend-colors')
      .data(colors)
      .enter()
      .append('div')
      .attr('class', 'v-legend-colors')
      .style('height', '8px')
      .style('width', `${color_width}px`)
      .style('background-color', d => d);

    const map_legend_labels = container
      .append('div')
      .attr('class', 'v-legend-labels-container')
      .attr('width', initialWidth);

    map_legend_labels
      .append('div')
      .attr('class', 'v-legend-label-spacer')
      .style('width', `${color_width / 2}px`);

    map_legend_labels.selectAll('.v-legend-labels')
      .data(breaks)
      .enter()
      .append('div')
      .attr('class', 'v-legend-labels')
      .style('width', `${color_width}px`)
      .html(d => d);

    map_legend_labels
      .append('div')
      .attr('class', 'v-legend-label-spacer')
      .style('width', `${color_width / 2}px`);

    // // -- map code -- // //

    const svg = container
      .append('svg')
      .attr('width', initialWidth)
      .attr('height', initialHeight);

    // calculate the projection scale based on the width
    // width is 320 to 780
    // scale is 450 to 940
    const mapScale = scaleLinear()
      .domain([320, 780])
      .range([450, 940]);

    // set the projection
    const projection = geoAlbersUsa()
      .translate([initialWidth / 2, initialHeight / 2])
      .scale(mapScale(initialWidth));

    // console.log('width:', initialWidth);

    // create a path
    const path = geoPath().projection(projection);

    // standard topojson setup for assigning an "object" in the file
    const states = topojson.feature(
      states_json,
      states_json.objects.cb_2020_us_state_20m,
    ).features;

    // console.log(states);

    svg.selectAll('.states')
      .data(states)
      .enter()
      .append('path')
      .attr('class', 'v-states')
      .attr('d', path)
      .style('fill', d => d.properties.fill)
      .style('stroke', 'none');

    // standard topojson setup for assigning an "object" in the file

    // objects key changes every week, so detecting it first
    // const topo_object_key = Object.keys(mapdata.objects)[0];
    // console.log('Using latest map object key:', topo_object_key);
    const regions = topojson.feature(
      mapdata,
      mapdata.objects[topo_object_key],
    ).features;

    svg.selectAll('.regions')
      .data(regions)
      .enter()
      .append('path')
      .attr('class', 'v-region')
      .attr('d', path)
      .style('fill', d => d.properties.fill)
      .style('stroke', d => d.properties.stroke);

    // standard topojson setup for assigning an "object" in the file
    const statelines = topojson.feature(
      innerlines,
      innerlines.objects.innerlines,
    ).features;

    svg.selectAll('.statelines')
      .data(statelines)
      .enter()
      .append('path')
      .attr('class', 'v-statelines')
      .attr('d', path)
      .style('fill', 'none')
      .style('stroke', '#4a4a4a')
      .style('stroke-width', '0.5px');

    // standard topojson setup for assigning an "object" in the file
    const state_names = topojson.feature(
      state_centers,
      state_centers.objects.state_centers,
    ).features;

    svg.selectAll('.state_names')
      .data(state_names)
      .enter()
      .append('text')
      .attr('d', path)
      .text(d => d.properties.STUSPS)
      .attr(
        'class',
        d => `v-state-names v-state-${d.properties.STUSPS.toLowerCase()}`,
      )
      .attr('x', (d) => {
        if (d.properties.STUSPS == 'PR') return null;
        const coords = projection([
          d.geometry.coordinates[0],
          d.geometry.coordinates[1],
        ]);
        return coords[0];
      })
      .attr('y', (d) => {
        if (d.properties.STUSPS == 'PR') return null;
        const coords = projection([
          d.geometry.coordinates[0],
          d.geometry.coordinates[1],
        ]);
        return coords[1];
      })
      .attr('text-anchor', 'middle')
      .attr('stroke', 'None')
      .attr('fill', 'None');

    // update height of svg to pym
    pymChild.sendHeight();
  };

  checkParams();

  // fetch data and draw the map
  if (mapParams.scale == 'high') {
    fetchData('https://ix.cnn.io/data/7day-rainfall/map-high-scale.json').then(drawMap);
  } else {
    fetchData('https://ix.cnn.io/data/7day-rainfall/map.json').then(drawMap);
  }
}
